import { withIncludeArchived } from '../../../services/archive.js';
// Toggle persistence + date formatting now live in the shared archive util.
export { SHOW_ARCHIVED_KEY, readShowArchived, writeShowArchived, formatArchiveDate } from '../../../services/archive.js';

const API_BASE_URL = '/decoupled-api/taxonomy_term/doc_directory/collection?display=decoupled';
// Une page du wiki est une `builder_page` RANGÉE dans un répertoire ; les pages
// de sites sont le même bundle, sans répertoire. Cette base n'est jamais appelée
// nue : ses deux appelants (DocSidebarTree) y ajoutent toujours un
// `filter[0][f]=field_directory`, qui cloisonne déjà la requête au wiki.
const PAGES_BASE_URL = '/decoupled-api/node/builder_page/collection?display=decoupled';

export function getApiBase(showArchived) {
    return withIncludeArchived(API_BASE_URL, showArchived);
}

export function getPagesBase(showArchived) {
    return withIncludeArchived(PAGES_BASE_URL, showArchived);
}

export async function fetchJson(url) {
    const res = await fetch(url, { credentials: 'include' });
    if (!res.ok) throw new Error(`Fetch failed: ${res.status}`);
    return res.json();
}

export function transformDirectories(items) {
    return (items || []).filter(Boolean).map((item) => {
        const d = item.data ?? item;
        const rawParent = d.parentId;
        const parentId = Array.isArray(rawParent)
            ? (rawParent[0] ? parseInt(rawParent[0], 10) : 0)
            : (rawParent ? parseInt(rawParent, 10) : 0);
        return { id: d.id, name: d.name, icon: d.icon || '', parentId: parentId || 0, type: 'directory', weight: parseInt(d.weight, 10) || 0, archived: d.archived || null };
    });
}

export function transformPages(items) {
    return (items || []).filter(Boolean).map((item) => {
        const d = item.data ?? item;
        return { id: d.id, title: d.title || 'Sans titre', icon: d.icon || '', directoryId: d.directoryId ? parseInt(d.directoryId, 10) : null, type: 'page', weight: parseInt(d.weight, 10) || 0, archived: d.archived || null };
    });
}

export function mergeAndSortByWeight(pages, dirs) {
    return [...pages, ...dirs].sort((a, b) => a.weight - b.weight);
}
